import { render, staticRenderFns } from "./CompanyFinancialReserve.vue?vue&type=template&id=2b6c6d23&scoped=true&"
import script from "./CompanyFinancialReserve.vue?vue&type=script&lang=js&"
export * from "./CompanyFinancialReserve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6c6d23",
  null
  
)

export default component.exports